module.exports = __webpack_public_path__ + "img/11.cd0636da.jpeg";